<template>
  <section class="mobile-images">
    <!-- 홍보 이미지들 -->
    <template v-for="(image, index) in images" :key="index">
      <div class="image-wrapper">
        <img
          :src="image.src"
          :alt="`홍보 이미지 ${index + 1}`"
          loading="lazy"
        />
      </div>
      <!-- home2.jpg 다음에 유튜브 영상 삽입 -->
      <div v-if="image.name === 'home2'" class="video-wrapper">
        <iframe
          src="https://www.youtube.com/embed/j4FL7_0jGQ8?autoplay=1&mute=1&loop=1&playlist=j4FL7_0jGQ8&controls=0&showinfo=0&rel=0&playsinline=1"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </template>

    <!-- 마지막: 상담 신청 폼 -->
    <div class="contact-form-section">
      <div class="form-header">
        <h3 class="form-title">상담 신청</h3>
        <p class="form-desc">연락처를 남겨주시면 빠르게 연락드립니다</p>
      </div>
      <form @submit.prevent="submitForm" class="contact-form">
        <input
          type="text"
          v-model="form.name"
          placeholder="이름"
          required
          :disabled="isSubmitting"
        />
        <PhoneInput v-model="form.phone" :disabled="isSubmitting" required />
        <label class="checkbox-label">
          <input type="checkbox" v-model="form.agreePrivacy" required :disabled="isSubmitting" />
          <span class="checkmark"></span>
          <span>개인정보 수집 및 이용 동의</span>
        </label>
        <button type="submit" class="submit-btn" :disabled="isSubmitting">
          {{ isSubmitting ? '등록 중...' : '상담 신청하기' }}
        </button>
      </form>
    </div>
  </section>
</template>

<script>
import { saveConsultation } from '@/firebase/consultationService'
import PhoneInput from '@/components/common/PhoneInput.vue'

export default {
  name: 'MobileImageSection',
  components: { PhoneInput },
  data() {
    return {
      images: [],
      isSubmitting: false,
      form: {
        name: '',
        phone: '',
        agreePrivacy: false
      }
    }
  },
  created() {
    const requireImages = require.context(
      '@/assets/mobile/',
      false,
      /^\.\/home\d+\.(jpg|jpeg|png|gif|webp)$/i
    )

    const sortedKeys = requireImages.keys().sort((a, b) => {
      const numA = parseInt(a.match(/\d+/)[0])
      const numB = parseInt(b.match(/\d+/)[0])
      return numA - numB
    })

    this.images = sortedKeys.map(key => ({
      src: requireImages(key),
      name: key.match(/\.\/(home\d+)/)[1]
    }))
  },
  methods: {
    async submitForm() {
      if (!this.form.agreePrivacy) {
        alert('개인정보 수집 및 이용에 동의해주세요.')
        return
      }
      this.isSubmitting = true
      try {
        const result = await saveConsultation({
          name: this.form.name,
          phone: this.form.phone
        }, 'mobile-form')
        if (result.success) {
          alert('등록이 완료되었습니다. 빠른 시간 내에 연락드리겠습니다.')
          this.form = { name: '', phone: '', agreePrivacy: false }
        } else {
          alert('오류가 발생했습니다. 다시 시도해주세요.')
        }
      } catch (error) {
        alert('오류가 발생했습니다. 다시 시도해주세요.')
      } finally {
        this.isSubmitting = false
      }
    }
  }
}
</script>

<style scoped>
.mobile-images {
  width: 100%;
}

.image-wrapper {
  width: 100%;
  line-height: 0;
}

.image-wrapper img {
  width: 100%;
  height: auto;
  display: block;
}

/* 유튜브 영상 */
.video-wrapper {
  width: 100%;
  position: relative;
  padding-bottom: 56.25%; /* 16:9 비율 */
  background: #000;
}

.video-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

/* 상담 신청 폼 섹션 */
.contact-form-section {
  width: 100%;
  padding: 40px 24px 30px;
  background: #182958;
  border: 2px solid var(--main-color1);
  border-left: none;
  border-right: none;
}

.form-header {
  text-align: center;
  margin-bottom: 24px;
}

.form-badge {
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 3px;
  color: var(--main-color1);
  margin-bottom: 12px;
}

.form-title {
  font-size: 24px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 8px;
}

.form-desc {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
}

.contact-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.contact-form input[type="text"],
.contact-form input[type="tel"] {
  width: 100%;
  padding: 16px;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  background: rgba(255, 255, 255, 0.95);
  color: #333;
}

.contact-form input::placeholder {
  color: #999;
}

.contact-form input:focus {
  outline: none;
  box-shadow: 0 0 0 2px var(--main-color1);
}

.contact-form :deep(.phone-segment) {
  padding: 16px 6px;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  background: rgba(255, 255, 255, 0.95);
  color: #333;
}

.contact-form :deep(.phone-segment:focus) {
  outline: none;
  box-shadow: 0 0 0 2px var(--main-color1);
}

.contact-form :deep(.phone-separator) {
  color: rgba(255, 255, 255, 0.7);
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 10px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 13px;
  cursor: pointer;
  padding: 8px 0;
}

.checkbox-label input[type="checkbox"] {
  display: none;
}

.checkmark {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-radius: 4px;
  position: relative;
  flex-shrink: 0;
}

.checkbox-label input:checked + .checkmark {
  background: var(--main-color1);
  border-color: var(--main-color1);
}

.checkbox-label input:checked + .checkmark::after {
  content: '';
  position: absolute;
  top: 2px;
  left: 6px;
  width: 5px;
  height: 10px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.submit-btn {
  width: 100%;
  padding: 16px;
  background: var(--main-color1);
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s;
  margin-top: 8px;
}

.submit-btn:active:not(:disabled) {
  transform: scale(0.98);
}

.submit-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
</style>